import { useEffect, useState } from "react";
import { KeyRound, Copy, EyeOff } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export function EncKeyReveal() {
  const [st, setSt] = useState(null);
  const [pwd, setPwd] = useState("");
  const [ask, setAsk] = useState(false);
  const [key, setKey] = useState("");
  useEffect(() => {
    api.get("/security/encryption-status").then((r) => setSt(r.data)).catch(() => {});
  }, []);
  if (!st?.key_configured) return null;
  const reveal = async () => {
    try {
      const { data } = await api.post("/security/reveal-encryption-key", { password: pwd });
      setKey(data.key); setAsk(false); setPwd("");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const copy = () => { navigator.clipboard?.writeText(key); toast.success("Skopiowano klucz szyfrowania"); };
  return (
    <div className="mb-2 rounded border border-emerald-800/60 bg-emerald-950/20 p-2 text-[11px]" data-testid="enc-key-box">
      <div className="flex flex-wrap items-center gap-2">
        <KeyRound size={13} className="text-emerald-400" />
        <span className="text-slate-300">Zaszyfrowane kopie otworzysz na innym serwerze tylko tym kluczem: <b className="font-mono text-emerald-200">{st.key_fingerprint}</b></span>
        {!key && !ask && <button onClick={() => setAsk(true)} className="text-cyan-300 hover:underline" data-testid="enc-key-show">Pokaż pełny klucz</button>}
      </div>
      {ask && (
        <div className="mt-1.5 flex flex-wrap items-center gap-2">
          <input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} onKeyDown={(e) => e.key === "Enter" && reveal()} placeholder="Twoje hasło"
            className="bg-slate-950 border border-slate-700 rounded px-2 py-1 text-xs text-white outline-none focus:ring-1 focus:ring-cyan-500" data-testid="enc-key-password" />
          <button onClick={reveal} className="bg-emerald-700 hover:bg-emerald-600 rounded px-2 py-1" data-testid="enc-key-confirm">Pokaż</button>
          <button onClick={() => { setAsk(false); setPwd(""); }} className="text-slate-400 hover:underline">Anuluj</button>
        </div>
      )}
      {key && (
        <div className="mt-1.5 flex flex-wrap items-center gap-2">
          <code className="font-mono text-emerald-100 bg-slate-950 border border-slate-700 rounded px-2 py-1 break-all select-all" data-testid="enc-key-value">{key}</code>
          <button onClick={copy} title="Kopiuj" className="text-cyan-300" data-testid="enc-key-copy"><Copy size={13} /></button>
          <button onClick={() => setKey("")} title="Ukryj" className="text-slate-400" data-testid="enc-key-hide"><EyeOff size={13} /></button>
          <span className="w-full text-amber-300/90">Zapisz go w bezpiecznym miejscu (np. menedżer haseł). Bez tego klucza zaszyfrowanej kopii nie da się przywrócić.</span>
        </div>
      )}
    </div>
  );
}
